import {asyncRoutes, constantRoutes} from '@/router';

function getFlatTreeArr(node) {
    let arr = [];

    let keys = Object.keys(node);
    let newData = {};
    keys.forEach(i => {
        if (i != 'children') {
            newData[i] = node[i];
        }
    });
    arr.push(newData);

    let child = node.children;
    if (child) {
        child.forEach(function (node) {
            arr = arr.concat(getFlatTreeArr(node));
        });
    }
    return arr;
}


/**
 * Filter asynchronous routing tables by recursion
 * @param routes 本地配置的异步路由,
 * @param navigation 接口获取的路由
 */
export function filterAsyncRoutes(routes, navigation) {
    const res = [];
    let allRoutes = [];
    routes.forEach(item => {
        allRoutes = allRoutes.concat(getFlatTreeArr(item));
    });

    navigation.forEach(item => {
        let matchItem = allRoutes.find(i => i.name == item.name);
        let isSingleHomePage = item.name==='home'&&(item.children||[]).length <= 0;
        let isSingleModuleNav = item.type === '0' && (item.children === undefined || item.children.length <= 0);
        // console.log('接口获取的路由',item,isSingleModuleNav);
        if (matchItem) {
            let navItem = {
                path: matchItem.path,
                name: matchItem.name,
                alwaysShow: !isSingleModuleNav,
                component: isSingleHomePage?() => import('@/views/Home.vue'): isSingleModuleNav ? () => import('@/views/NoPermission.vue') : matchItem.component,
                hidden: false,
                // meta: matchItem.meta,
                meta: Object.assign({}, matchItem.meta, {id: item.id}),
            };
            let child = item.children;
            if (child && child.length > 0) {
                navItem.children = [];
                child.forEach(nav2 => {
                    let tabPages = [];
                    if (nav2.type == '0' && nav2.multiple_page == '1') {
                        if ((nav2.children || []).length > 0) {
                            state.tabsMap[nav2.name] = nav2.children;
                        }

                        tabPages = (nav2.children || []).map(item => {

                            let matchItem = allRoutes.find(item2 => item.name == item2.name);
                            if(matchItem){
                                item.path = matchItem.path;
                                item.meta = matchItem.meta;
                                if(matchItem.component){
                                    item.component = matchItem.component;
                                }
                            }
                            return item;
                        });
                    }

                    let matchItem = allRoutes.find(item => item.name == nav2.name);
                    if (matchItem) {
                        let allRoutesNames = allRoutes.map(item => item.name);
                        let nav2Item = {
                            path: matchItem.path,
                            name: matchItem.name,
                            component: matchItem.component,
                            hidden: false,
                            meta: Object.assign({}, matchItem.meta, {id: nav2.id}),
                        };

                        if (tabPages.length > 0) {

                            nav2Item.children = tabPages.filter(item => allRoutesNames.includes(item.name)).map(item=>{
                                item.meta.id = item.id;
                                item.meta.pid = item.pid;
                                return item;
                            });
                        }

                        navItem.children.push(nav2Item);
                    }
                })
            }
            res.push(navItem);
        }
    });
    return res
}

export function filterTabPages(list, result) {
    list.forEach(item => {
        if (item.type === '0' && item.multiple_page === '1') {
            result.push(item);
        }
        if (item.children && item.children.length > 0) {
            return filterTabPages(item.children, result);
        }
    });
    return result;
}

const state = {
    routes: [],
    addRoutes: [],
    tabsMap: {},
};

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes;
        state.routes = constantRoutes.concat(routes);
    },
    CLEAR_ROUTES(state) {
        state.routes = [];
        state.addRoutes = [];
    },
    ADD_TABS_MAP(state, pages) {
        pages.forEach(item=>{
            state.tabsMap[item.name] = item.children;
        });
    }
};

const actions = {
    generateRoutes({commit}, navigation) {
        return new Promise(resolve => {
            let accessedRoutes = filterAsyncRoutes(asyncRoutes, navigation);
            commit('SET_ROUTES', accessedRoutes);

            let tabPages = filterTabPages(navigation, []);
            commit('ADD_TABS_MAP', tabPages);
            resolve(accessedRoutes)
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
